/* eslint-disable no-underscore-dangle */
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';

import styles from './ForumDetailInfo.module.less';
// import { CONTEXT } from '../../../config';
import SoftTag from '../../../components/Forum/SoftTag/SoftTag';
import { formatNumber } from '../../../utils/utils';
import dayjs from 'dayjs';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectForum = createSelector(
  state => state.forum,
  forum => forum,
);
export default props => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { forumDetailMore = {}, forumDetail = {} } = props;
  const logInfoData = useSelector(selectLogInfo);
  const { forumCommentList } = useSelector(selectForum);

  useEffect(() => {}, []);

  return (
    <div className={styles.details}>
      <div className={styles.details_left}>
        <div className={styles.details_title}>{forumDetailMore.title}</div>
        {forumDetailMore && forumDetailMore.passInfos && forumDetailMore.passInfos.length > 0 && (
          <SoftTag forumData={forumDetailMore} logInfo={{ source: 'Forum_Detail' }} />
        )}
      </div>
      <div className={styles.forum_rsc}>
        <div className={styles.forum_rsc_time}>
          {forumDetailMore.createTime
            ? dayjs(forumDetailMore.createTime).format('YYYY-MM-DD HH:mm')
            : ''}
        </div>
        <div className={styles.forum_rscs}>
          <div className={styles.forum_rsc_item_}>
            <span className={`${styles.forum_icon} iconfont icon-fread`}></span>
            <span className={styles.forum_rsc_text}>
              {formatNumber(forumDetail.watchCount || 0)}
            </span>
          </div>
          <div className={styles.forum_rsc_item}>
            <span className={`${styles.forum_icon} iconfont icon-fspot`}></span>
            <span className={styles.forum_rsc_text}>{formatNumber(forumDetail.zanCount || 0)}</span>
          </div>
          <div className={styles.forum_rsc_item}>
            <span className={`${styles.forum_icon} iconfont icon-fcomment`}></span>
            <span className={styles.forum_rsc_text}>
              {/* {formatNumber(forumDetail.commentCount || 0)} */}
              {formatNumber(
                (forumCommentList &&
                  forumCommentList.dataList &&
                  forumCommentList.dataList.length) ||
                  0,
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
